import { render, staticRenderFns } from "./AutoAuth.vue?vue&type=template&id=aaa9c4e2&scoped=true&"
import script from "./AutoAuth.vue?vue&type=script&lang=js&"
export * from "./AutoAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa9c4e2",
  null
  
)

export default component.exports